import axios from "axios";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:4000";
const BASE_URL = `${BACKEND_URL}/api/v1`;

/**
 * Solicitar opciones para registrar credencial biométrica.
 * Requiere autenticación (token JWT).
 */
export const webauthnRegisterOptions = async (token) => {
  const res = await axios.post(`${BASE_URL}/webauthn/register-options`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

/**
 * Verificar y guardar credencial biométrica.
 * Requiere autenticación (token JWT).
 */
export const webauthnRegisterVerify = async (token, credential) => {
  const res = await axios.post(`${BASE_URL}/webauthn/register-verify`, credential, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

/**
 * Solicitar opciones para login biométrico (sin auth).
 */
export const webauthnLoginOptions = async (email) => {
  const res = await axios.post(`${BASE_URL}/webauthn/login-options`, { email });
  return res.data;
};

/**
 * Verificar login biométrico y obtener tokens JWT (sin auth).
 */
export const webauthnLoginVerify = async (userId, response) => {
  const res = await axios.post(`${BASE_URL}/webauthn/login-verify`, { userId, response });
  return res.data;
};

/**
 * Eliminar una credencial biométrica.
 * Requiere autenticación (token JWT).
 */
export const webauthnRemoveCredential = async (token, credentialID) => {
  const res = await axios.post(`${BASE_URL}/webauthn/remove-credential`, { credentialID }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};
